import { ContractsTaxonomiesDocument, ContractsTaxonomiesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type ContractsTaxonomy = NonNullable<
  NonNullable<ContractsTaxonomiesQuery['contracts']>['taxonomies']
>[number]

export const useFetchContractsTaxonomies = (legalEntityIds: string[]) => {
  const {
    data: taxonomies,
    loading,
    refetch,
  } = useQuery(ContractsTaxonomiesDocument, {
    variables: {
      legalEntityIds: legalEntityIds,
    },
  })

  return {
    loading,
    refetch,
    taxonomies: new ContractsTaxonomyCollection(taxonomies?.contracts.taxonomies || []),
  }
}

class ContractsTaxonomyCollection {
  contractTaxonomies: ContractTaxonomy[]

  constructor(contractTaxonomies: ContractsTaxonomy[]) {
    this.contractTaxonomies = contractTaxonomies.map((taxonomy) => {
      return new ContractTaxonomy(taxonomy)
    })
  }

  activeTaxonomies(): ContractTaxonomy[] {
    return this.contractTaxonomies.filter((taxonomy) => taxonomy.isActive)
  }
}

export class ContractTaxonomy {
  id: string
  archived: boolean
  default: boolean
  legalEntityId: string
  name: string

  constructor(taxonomy: ContractsTaxonomy) {
    this.id = taxonomy.id
    this.archived = taxonomy.archived
    this.default = taxonomy.default
    this.legalEntityId = taxonomy.legalEntityId
    this.name = taxonomy.name
  }

  get isArchived(): boolean {
    return this.archived
  }

  get isActive(): boolean {
    return !this.archived
  }

  get isDefault(): boolean {
    return this.default
  }
}
